export const FEATURE_SET_TAG_WIDTH_SMALL = 70;
export const FEATURE_SET_TAG_WIDTH_MEDIUM = 90;
export const FEATURE_SET_TAG_WIDTH_LARGE = 120;
